import { HttpClient } from '@adapters/HttpClient';
import { Order } from '@modules/Orders/List/models/Orders';

export interface CustomerOrdersResponse {
  data: Order[];
  meta: {
    currentPage: number;
    lastPage: number;
    total: number;
  };
}

export class CustomerOrdersApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getOrdersByCustomerIds(customerIds: number[]): Promise<CustomerOrdersResponse> {
    const params = {
      customer_ids: customerIds.join(','),
    };

    const response = await this.httpClient.get<any>(
      '/orders',
      params,
      {},
      false // No mostrar loading global
    );

    return {
      data: response.data || [],
      meta: response.meta || {
        currentPage: 1,
        lastPage: 1,
        total: response.data?.length || 0,
      },
    };
  }
}


